<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <SkillcertifyContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import SkillcertifyContent from "~~/codepresso-renewal/content/SkillcertifyContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "SkillCertify: 개발자 실무 역량 평가 | 코드프레소",
  meta: [
    { name: "description", content: "돌아가는 코드와 좋은 코드는 다릅니다. 실무 기준 프로젝트 과제와 부정행위 감지 기능으로 개발 역량을 정밀하게 검증합니다." },
    { name: "title", content: "SkillCertify: 개발자 실무 역량 평가 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "SkillCertify: 개발자 실무 역량 평가 | 코드프레소" },
    { property: "og:description", content: "돌아가는 코드와 좋은 코드는 다릅니다. 실무 기준 프로젝트 과제와 부정행위 감지 기능으로 개발 역량을 정밀하게 검증합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/skillcertify.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
